import { render } from "./WidgetBase.vue?vue&type=template&id=bdc3b1cc&ts=true"
import script from "./WidgetBase.vue?vue&type=script&lang=ts"
export * from "./WidgetBase.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__